import { apiUrls } from "./apiUrls";

export const AdminAndUserStatusActions = {

    DELETE_ADMIN: {
        name: 'DeleteAdmin',
        label: 'Sil',
        icon: 'cancel',
        endpoint: apiUrls.AdminDelete,
    },
    DELETE_USER: {
        name: 'DeleteUser',
        label: 'Sil',
        icon: 'cancel',
        endpoint: apiUrls.UserDelete,
    },
    CHANGE_REQUESTED: {
        name: 'ChangeRequest',
        label: 'Güncelle',
        icon: 'edit',
        endpoint: apiUrls.AdminUpdate,
    },
    CHANGE_PASSWORD: {
        name: 'ChangePassword',
        label: 'Güncelle',
        icon: 'edit',
        endpoint: apiUrls.AdminPasswordUpdate,
    },
    USER_CHANGE_PASSWORD: {
        name: 'UserChangePassword',
        label: 'Güncelle',
        icon: 'editPassword',
        endpoint: apiUrls.UserPasswordUpdate,
    }
};

export const BoostStatusActions = {
    INACTIVE: {
        name: 'StatusActiveToInactiveUpdate',
        label: 'Güncelle',
        icon: 'statusUpdate',
        endpoint: apiUrls.BoostStatusInactivateUpdate
    },
    ACTIVE: {
        name: 'StatusInactiveToActiveUpdate',
        label: 'Güncelle',
        icon: 'statusUpdate',
        endpoint: apiUrls.BoostStatusActivateUpdate
    },

};
